import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
const Container = styled.div`
  top: 0;
  z-index: 98;
  position: absolute;
  min-height: 100%;
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
`;
const SpinnerAnimation = keyframes`0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }`;
const Spinner = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;
  &::after {
    content: "";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid black;
    border-color: black transparent black transparent;
    animation: ${SpinnerAnimation} 1.2s linear infinite;
  }
`;

export default class LoadingSpinner extends Component {
  render() {
    return (
      <Container>
        <Spinner />;
      </Container>
    );
  }
}
